exports.PRODUCTION_API_URL = 'https://api.chipndoodle.com';
exports.DEVELOPMENT_API_URL = 'http://' + document.location.hostname + ':8181';
exports.APP_KEY = 'chipndoodle';
exports.USER_DEFAULT_PATH = '/animals';
exports.RECAPTCHA_SITE_KEY = '6Lca5FsUAAAAAOKbqh9ZlhUAJQTVknJfw5jCqLVG';
exports.SPECIES_DEFAULT = 'dog';
exports.GOOGLE_MAPS_API_KEY = 'AIzaSyB2w3I5yIp7v_jjHY7v9ZnchEVVAusy1QU';

exports.CERTIFICATE_PRICE_IN_ZAR = 0
exports.PAYFAST_MERCHANT_ID = process.env.NODE_ENV === 'production' ? '24542363' : '10033723'
exports.PAYFAST_MERCHANT_KEY = process.env.NODE_ENV === 'production' ? '7sjj7kmcyfig8' : '7mf7q37s2o65r'

exports.API_BASE = process.env.NODE_ENV === 'production' ? 'https://api.chipndoodle.com' : 'http://localhost:8181'
exports.WEB_BASE = process.env.NODE_ENV === 'production' ? 'https://chipndoodle.com' : 'http://localhost:3000'

exports.SPECIES = {

  'dog': {

    label: 'Dog',

  },
  'cat': {

    label: 'Cat',

  },
  'horse': {

    label: 'Horse',

  },
  'sheep': {

    label: 'Sheep',

  },
  'cattle': {

    label: 'Cattle',

  },
  'primate': {

    label: 'Primate',

  },
  'snake': {

    label: 'Snake',

  },
  'bird': {

    label: 'Bird',

  },

};

exports.MAP_STYLES = [{ "featureType": "all", "elementType": "labels.text", "stylers": [{ "color": "#000000" }, { "visibility": "simplified" }] }, { "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "hue": "#ff0000" }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ff0000" }, { "visibility": "simplified" }] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#000000" }, { "visibility": "off" }] }, { "featureType": "administrative.country", "elementType": "geometry.fill", "stylers": [{ "visibility": "off" }, { "color": "#ff0000" }] }, { "featureType": "administrative.country", "elementType": "geometry.stroke", "stylers": [{ "visibility": "on" }] }, { "featureType": "administrative.country", "elementType": "labels", "stylers": [{ "visibility": "simplified" }, { "color": "#9b30f2" }] }, { "featureType": "administrative.province", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.locality", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "color": "#7620bd" }] }, { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.man_made", "elementType": "geometry", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.man_made", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.natural", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.natural.landcover", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape.natural.terrain", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }, { "visibility": "simplified" }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "color": "#c4c6f4" }] }, { "featureType": "road.highway", "elementType": "labels", "stylers": [{ "visibility": "off" }, { "color": "#d3d4f3" }] }, { "featureType": "road.highway", "elementType": "labels.text", "stylers": [{ "visibility": "simplified" }, { "color": "#000000" }, { "weight": "0.01" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "visibility": "simplified" }, { "weight": "0.01" }] }, { "featureType": "transit.station.bus", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#eeeeff" }, { "visibility": "on" }] }];